module.exports = __webpack_public_path__ + "static/media/diners.4fe60718.png";